import { memo, useCallback, useMemo } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import { Button } from "@/components/ui/button/button";

import { BasicInfoLabelWithTextLayout } from "../../layout";

type Props = {
	isMailMagazineAccept?: InputMaybe<boolean>;
	//
	onUpdate: (statusMailMagazine: boolean) => void;
};

export const IsMailMagazineAcceptOfBasicInfoCompositions = memo(({ isMailMagazineAccept, onUpdate }: Props) => {
	/**
	 * メルマガ希望を更新
	 */
	const handleClickSave = useCallback(() => {
		/**
		 * @todo confirm を追加するか検討
		 */
		onUpdate(!isMailMagazineAccept);
	}, [isMailMagazineAccept, onUpdate]);

	const labelText = useMemo(() => {
		return isMailMagazineAccept ? "希望する" : "希望しない";
	}, [isMailMagazineAccept]);
	const buttonText = useMemo(() => {
		return !isMailMagazineAccept ? "希望するに変更" : "希望しないに変更";
	}, [isMailMagazineAccept]);

	return (
		<div className="flex flex-wrap items-center gap-x-5 gap-y-1 sm:gap-x-10">
			<BasicInfoLabelWithTextLayout label="メルマガ配信" textChildren={<p>{labelText}</p>} />

			<Button variant="outline" type="button" size="sm" onClick={handleClickSave}>
				{buttonText}
			</Button>
		</div>
	);
});
